<template>
  <svg class='tablet' width='100' height='100'>
    <g class='tablet-device'>
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='
          M -5,75 L 45,35 Q 50,30 55,35 L 105,65
        '
      />
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
            class='screen'
        d='
          M -5,85 L 45,45 Q 50,40 55,45 L 105,75
          L 105,105 -5,105 -5,85
        '
      />
      <ellipse fill='none' stroke='#2D2D2D' stroke-width='2'
              cx='85' cy='57' rx='4' ry='3'
      />
    </g>
    <g class='pencil'>
      <path fill='none' stroke='#2D2D2D' stroke-width='2'
        d='
          M 65,-5 L 15,35 12,41 18,41 75,-5
          M 20,30 L 26,36
        '
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TabletSvg',
}
</script>

<style scoped>
@keyframes dim {
  0% {
    fill: #F2BF5C;
  }
  50% {
    fill: #F2BF5C;
  }
  100% {
    fill: #2D2D2D;
  }
}

.tablet {
  border: 2px solid #2D2D2D;
}

.animate .screen {
  animation: dim 5s ease;
}

.screen {
  transition: fill 200ms ease;
  fill: #2D2D2D;
}

.screen:hover {
  fill: #F2BF5C;
  transition: fill 200ms ease;
}
</style>
